import {
    useContext,
    useMemo,
} from 'react'
import {EmbedContext} from 'components/EmbedContext'
import {NinchatEnvironmentConfig} from 'embed/types'
import {useAppSelectorWithShallowEquality} from '../../hooks'

type UiStorageState = {
    chat_density?: string
    language?: NinchatEnvironmentConfig['language']
    theme?: string
}

const useUiState = () => {
    const embed = useContext(EmbedContext)
    const uiState = useAppSelectorWithShallowEquality(({ninchat}) => ({
        ...ninchat.user_settings.language && {language: ninchat.user_settings.language},
        ...ninchat.user_settings.theme && {theme: ninchat.user_settings.theme},
        ...ninchat.user_settings.chat_density && {chat_density: ninchat.user_settings.chat_density},
    }))

    const language = embed?.language || uiState.language

    return useMemo<UiStorageState>(() => ({
        ...uiState,
        language,
    }), [language, uiState])
}

export {
    useUiState,
}
